import { sprintf } from "sprintf-js";
import { g_availablePagesInSection, NU_TO_PU, PU_TO_NU, UNIT_TO_DPI } from "../constants";
export function compareObject(curr, next, header = "") {
    for (const [key, value] of Object.entries(next)) {
        if (curr[key] !== value) {
            console.log(`[${header}] state[${key}] was changed, from "${curr[key]} to "${value}"`);
        }
    }
}
export function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : ((r & 0x3) | 0x8);
        return v.toString(16);
    });
}
export function makePdfId(fingerprint, pagesPerSheet) {
    return fingerprint + "/" + pagesPerSheet.toString();
}
export function makeNPageId(pageInfo) {
    const nPageId = (pageInfo.section << 56) + (pageInfo.owner << 36) + (pageInfo.book << 16) + pageInfo.page;
    return nPageId;
}
export function makeNPageRangeIdStr(startSobp, numPages) {
    return `${makeNPageIdStr(startSobp)}-${numPages})}`;
}
export function makeNPageIdStr(pageInfo, separator = ".") {
    if (pageInfo) {
        const { section, owner, book, page } = pageInfo;
        if (page !== undefined)
            return `${section}${separator}${owner}${separator}${book}${separator}${page}`;
        if (book !== undefined)
            return `${section}${separator}${owner}${separator}${book}`;
        if (owner !== undefined)
            return `${section}${separator}${owner}`;
        if (section !== undefined)
            return `${section}`;
        return `${section}${separator}${owner}${separator}${book}${separator}${page}`;
    }
    return `${pageInfo}`;
}
/**
 * get IPageSOBP from pageId string ("s.o.b.p")
 *
 * @static
 * @param {string} pageId
 * @return IPageSOBP
 * @memberof InkStorage
 */
export function getPageSOBP(pageId) {
    const arr = pageId.split(".");
    if (arr.length !== 4) {
        return {
            section: -1,
            owner: -1,
            book: -1,
            page: -1,
        };
    }
    const ret = {
        section: parseInt(arr[0]),
        owner: parseInt(arr[1]),
        book: parseInt(arr[2]),
        page: parseInt(arr[3]),
    };
    return ret;
}
export function cloneObj(obj) {
    return JSON.parse(JSON.stringify(obj));
}
export function isSameObject(a, b) {
    if (a === b)
        return true;
    if (a === undefined && b)
        return false;
    if (a && b === undefined)
        return false;
    if (Object.keys(a).length !== Object.keys(b).length)
        return false;
    for (const key in a) {
        if (typeof a[key] === "object") {
            if (!isSameObject(a[key], b[key]))
                return false;
        }
        else if (a[key] !== b[key]) {
            // console.log(`[printOption diff] key=${key} values="${a[key]}", "${b[key]}`);
            return false;
        }
    }
    return true;
}
function isValidPage(pg) {
    if (pg === undefined || pg === null)
        return false;
    if (pg.section === undefined || pg.section === null)
        return false;
    if (pg.section < 0)
        return false;
    return true;
}
export function isSamePage(pg1, pg2) {
    if (!isValidPage(pg1) && !isValidPage(pg2))
        return true;
    if (isValidPage(pg1) && !isValidPage(pg2))
        return false;
    if (!isValidPage(pg1) && isValidPage(pg2))
        return false;
    if (pg1.page !== pg2.page || pg1.book !== pg2.book || pg1.owner !== pg2.owner || pg1.section !== pg2.section) {
        return false;
    }
    return true;
}
export function isSameH(h1, h2) {
    if (h1.a !== h2.a)
        return false;
    if (h1.b !== h2.b)
        return false;
    if (h1.c !== h2.c)
        return false;
    if (h1.d !== h2.d)
        return false;
    if (h1.e !== h2.e)
        return false;
    if (h1.f !== h2.f)
        return false;
    if (h1.g !== h2.g)
        return false;
    if (h1.h !== h2.h)
        return false;
    return true;
}
export function includesPage(pgs, pg2) {
    for (let i = 0, l = pgs.length; i < l; i++)
        if (isSamePage(pgs[i], pg2))
            return true;
    return false;
}
export function unionPages(pgs1, pgs2) {
    const pages = [...pgs1];
    pgs2.forEach(pg => {
        if (!includesPage(pages, pg))
            pages.push(pg);
    });
    return pages;
}
export function isValidSOBP(pg) {
    if (!Object.prototype.hasOwnProperty.call(pg, "section"))
        return false;
    if (!Object.prototype.hasOwnProperty.call(pg, "owner"))
        return false;
    if (!Object.prototype.hasOwnProperty.call(pg, "book"))
        return false;
    if (!Object.prototype.hasOwnProperty.call(pg, "page"))
        return false;
    return true;
}
// export function isPageInRange(pg: IPageSOBP, arrStart: IPageSOBP, numPages: number): boolean {
//   if (pg === undefined) return false;
//   // alert( `${arrStart}`)
//   if (pg.book !== arrStart.book || pg.owner !== arrStart.owner || pg.section !== arrStart.section) {
//     return false;
//   }
//   const arr: number[] = [];
//   const availablePages = availablePagesInSection(arrStart.section);
//   for (let i = 0; i < numPages; i++) {
//     const page = (arrStart.page + i + availablePages) % availablePages;
//     arr.push(page);
//   }
//   return arr.indexOf(pg.page) >= 0;
// }
export function deepClone(obj) {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    const result = Array.isArray(obj) ? [] : {};
    for (const key of Object.keys(obj)) {
        result[key] = deepClone(obj[key]);
    }
    return result;
}
export function getNowTimeStr() {
    const now = new Date();
    const timeStr = sprintf("%04d-%02d-%02d %02d:%02d:%02d.%03d", now.getFullYear(), now.getMonth() + 1, now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
    return timeStr;
}
export function unixToDateStr(t, miliseconds = false) {
    const date = new Date(t);
    const hours = date.getHours();
    let minutes = "0" + date.getMinutes();
    let seconds = "0" + date.getSeconds();
    let day = "0" + date.getDate();
    const dayWeek = date.getDay();
    let month = "0" + (date.getMonth() + 1);
    const year = date.getFullYear();
    minutes = minutes.substr(-2);
    seconds = seconds.substr(-2);
    day = day.substr(-2);
    month = month.substr(-2);
    if (miliseconds) {
        // let mili = "00" + (t % 1000);
        // mili = mili.substr(-3);
        return year + "/" + month + "/" + day + " " + hours + ":" + minutes + ":" + seconds + "." + miliseconds;
    }
    return `${year}/${month}/${day}(${"일월화수목금토".substr(dayWeek, 1)}) ${hours}:${minutes}:${seconds}`;
}
export function addZeros(num, digit) {
    // 자릿수 맞춰주기
    let zero = "";
    num = num.toString();
    if (num.length < digit) {
        for (let i = 0; i < digit - num.length; i++) {
            zero += "0";
        }
    }
    return zero + num;
}
export function availablePagesInSection(section) {
    return g_availablePagesInSection[section] ? g_availablePagesInSection[section] : 4096;
}
export function getNextNcodePage(curr, delta = 1) {
    const { section, owner, book } = curr;
    const page = (curr.page + delta) % availablePagesInSection(section);
    const pi = {
        section, owner, book, page,
    };
    return pi;
}
/**
 * shouldComponentUpdated 등에서 쓰이는 상태 비교 디버거 메시지
 * @param prefix - prefix string of debug message
 * @param prevProps
 * @param nextProps
 * @param prevState
 * @param nextState
 */
export function dumpDiffPropsAndState(prefix, prevProps, nextProps, prevState = undefined, nextState = undefined) {
    let isChanged = false;
    for (const [key, value] of Object.entries(nextProps)) {
        // if (typeof value === "function" || typeof value === "object") continue;
        if (prevProps[key] !== value) {
            isChanged = true;
        }
    }
    if (prevState && nextState) {
        for (const [key, value] of Object.entries(nextState)) {
            // if (typeof value === "function" || typeof value === "object") continue;
            if (prevState[key] !== value) {
                isChanged = true;
            }
        }
    }
    console.log("");
    if (!isChanged) {
        console.log(`[${prefix}] =============== Properties & State NOT CHANGED`);
        return;
    }
    console.log(`[${prefix}] =============== Properties & State ===========================================================================================`);
    for (const [key, value] of Object.entries(nextProps)) {
        // if (typeof value === "function" || typeof value === "object") continue;
        if (prevProps[key] !== value) {
            console.log(`[${prefix}] PROPERTY [${key}] was changed, "${prevProps[key]}" ==> "${value}"`);
        }
    }
    // console.log(`[${prefix}] State .......................................................................................................................`);
    if (prevState && nextState) {
        for (const [key, value] of Object.entries(nextState)) {
            // if (typeof value === "function" || typeof value === "object") continue;
            if (prevState[key] !== value) {
                console.log(`[${prefix}] STATE    [${key}] was changed, "${prevState[key]}" ==> "${value}"`);
            }
        }
    }
    // console.log(`[${prefix}]==============================================================================================================================`);
}
export function clearCanvas(canvas, ctx = undefined, color = "rgb(255,255,255)") {
    if (!ctx)
        ctx = canvas.getContext("2d");
    ctx.save();
    ctx.fillStyle = color;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
export function drawSingleCrossMark(ctx, x, y, len) {
    const line_width = 4;
    const line_len = len;
    ctx.strokeStyle = "rgb(255, 0, 0)";
    ctx.save();
    ctx.beginPath();
    ctx.lineWidth = line_width;
    // 2020/08/31 kitty
    // canvas_context.arc(x, y, r, r, 0, Math.PI * 2, true); // Outer circle
    ctx.moveTo(x, y - line_len);
    ctx.lineTo(x, y + line_len);
    ctx.moveTo(x - line_len, y);
    ctx.lineTo(x + line_len, y);
    ctx.stroke();
    ctx.restore();
}
export function drawCrossMark(arg) {
    const ratio = arg.drawMarkRatio;
    const d = arg.w * ratio;
    const x = new Array(3);
    const y = new Array(3);
    x[0] = arg.x + d;
    y[0] = arg.y + d;
    x[1] = arg.x + arg.w - d;
    y[1] = arg.y + arg.h - d;
    x[2] = arg.x + arg.w / 2;
    y[2] = arg.y + arg.h / 2;
    const markPos = arg.markPos < 3 ? arg.markPos : 2;
    const len = arg.w * 0.04;
    drawSingleCrossMark(arg.ctx, x[markPos], y[markPos], len);
    return { x: x[markPos], y: y[markPos] };
}
function convertUnitToPt(unit, value) {
    let multiplier;
    switch (unit) {
        case 'inch':
            multiplier = 72;
            break;
        case 'pu':
            multiplier = 1;
            break;
        case 'nu':
            multiplier = NU_TO_PU;
            break;
        case '600dpi':
            multiplier = 72 / 600;
            break;
        case 'pt':
            multiplier = 1;
            break;
        case 'mm':
            multiplier = 72 / 25.4;
            break;
        case 'cm':
            multiplier = 72 / 2.54;
            break;
        case 'in':
            multiplier = 72;
            break;
        case 'px':
            multiplier = 96 / 72;
            break;
        case 'css':
            multiplier = 72 / 96;
            break;
        case 'pc':
            multiplier = 12;
            break;
        case 'em':
            multiplier = 12;
            break;
        case 'ex':
            multiplier = 6;
            break;
        default:
            throw new Error('Invalid unit: ' + unit);
    }
    return value * multiplier;
}
export function convertUnit(fromUnit, value, toUnit) {
    const points = convertUnitToPt(fromUnit, value);
    let multiplier;
    switch (toUnit) {
        case 'inch':
            multiplier = 1 / 72;
            break;
        case 'pu':
            multiplier = 1;
            break;
        case 'nu':
            multiplier = PU_TO_NU;
            break;
        case '600dpi':
            multiplier = 600 / 72;
            break;
        case 'pt':
            multiplier = 1;
            break;
        case 'mm':
            multiplier = 25.4 / 72;
            break;
        case 'cm':
            multiplier = 2.54 / 72;
            break;
        case 'in':
            multiplier = 1 / 72;
            break;
        case 'px':
            multiplier = 72 / 96;
            break;
        case 'css':
            multiplier = 96 / 72;
            break;
        case 'pc':
            multiplier = 1 / 12;
            break;
        case 'em':
            multiplier = 1 / 12;
            break;
        case 'ex':
            multiplier = 1 / 6;
            break;
        default:
            throw new Error('Invalid unit: ' + toUnit);
    }
    return points * multiplier;
}
export function getFilenameOnly(str) {
    const ext = getExtensionName(str);
    let name = str.split('/').pop().replace("." + ext, '');
    name = name.split('\\').pop().replace("." + ext, '');
    return name;
}
export function getExtensionName(str) {
    const re = /(?:\.([^.]+))?$/;
    const ext = re.exec(str)[1]; // "txt"
    return ext;
}
export function getNcodedPdfName(filename, pageInfo, pagesPerSheet, serialNum = null) {
    const name = getFilenameOnly(filename);
    const { section, owner, book, page } = pageInfo;
    const fn = `${name}_${pagesPerSheet}(${section}_${owner}_${book}_${page})_${serialNum !== null ? `${serialNum}_` : ""}ncoded.pdf`;
    return fn;
}
export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
function rgb2Hex(rgb) {
    const splitted = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return (splitted && splitted.length === 4) ? "#" +
        ("0" + parseInt(splitted[1], 10).toString(16)).slice(-2) +
        ("0" + parseInt(splitted[2], 10).toString(16)).slice(-2) +
        ("0" + parseInt(splitted[3], 10).toString(16)).slice(-2) : '';
}
export function hex2ColorObject(hex) {
    if (hex.length !== 7 && hex.length !== 4)
        hex = rgb2Hex(hex);
    let c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        const r = (c >> 16) & 255;
        const g = (c >> 8) & 255;
        const b = c & 255;
        return { r, g, b };
    }
    throw new Error('Bad Hex');
}
export function stringToDpiNum(unit) {
    let dpi = UNIT_TO_DPI[unit];
    if (!dpi) {
        const index = unit.indexOf("dpi");
        if (index > 0)
            dpi = parseInt(unit.substr(0, index));
        else
            dpi = parseInt(unit);
    }
    return dpi;
}
export function autoSetDpi(opt) {
    if (opt.unit && opt.dpi === undefined) {
        opt.dpi = stringToDpiNum(opt.unit);
    }
    return opt;
}
export function scalePoint(pt, scale) {
    pt.x = pt.x / scale;
    pt.y = pt.y / scale;
    return pt;
}
export function callstackDepth() {
    const callstack = new Error().stack.toString();
    const lines = callstack.split("\n");
    const re = /at\s(.+)\.(.+)\s\((.+)\)/;
    // let cnt = 0;
    let spc = "";
    let caller = sprintf("%20s", "");
    for (let i = 2, br = true; br; i++) {
        // cnt++;
        spc += "  ";
        if (!lines[i]) {
            br = false;
        }
        else {
            const arg = lines[i].split(re);
            // console.log(`VIEW SIZE   ${ arg.length } ${ lines[i] } `);
            if (arg.length !== 5) {
                br = false;
                const root = arg[0].split(/at\s(.+)\s\(/);
                caller = sprintf("%30s", root[1]);
                // console.log(arg);
            }
        }
    }
    return " " + caller + spc;
}
export function isSameRect(rc1, rc2) {
    if (!rc1 && !rc2)
        return true;
    if ((!rc1 && rc2) || (rc1 && !rc2))
        return false;
    return rc1.x === rc2.x && rc1.y === rc2.y && rc1.width === rc2.width && rc1.height === rc2.height;
}
/**
 * crop range를 처리하기 위한 루틴
 *
 * @export
 * @param {INcodeSOBPRect} curr_rc
 * @param {INcodeSOBPRect} next_rc
 * @return {*}  {boolean}
 */
export function isSamePageRect(curr_rc, next_rc) {
    if (!next_rc)
        return true;
    if (!curr_rc && next_rc) {
        if (next_rc.rect) {
            console.log(`return true`);
            return false;
        }
        else {
            console.log(`return false`);
            return true;
        }
    }
    // curr_rc && next_rc
    if (!next_rc.rect)
        return true;
    if (!curr_rc.rect && next_rc.rect)
        return false;
    const rectFlag = isSameRect(curr_rc.rect, next_rc.rect);
    // pageInfo에 wild card가 들어 있으면, 페이지와 상관 없이 영역만으로 판단
    if (!next_rc.pageInfo)
        return rectFlag;
    const pageFlag = isSamePage(curr_rc.pageInfo, next_rc.pageInfo);
    return pageFlag && rectFlag;
}
export function hasNullPageInfo(cr) {
    if (!cr)
        return true;
    if (!cr.pageInfo)
        return true;
    if (!cr.pageInfo.owner)
        return true;
    if (cr.pageInfo.owner === -1)
        return true;
    return false;
}
export function hasSamePage(prev_cr, next_cr) {
    if (hasNullPageInfo(next_cr))
        return true;
    if (hasNullPageInfo(prev_cr))
        return true;
    return isSamePage(prev_cr.pageInfo, next_cr.pageInfo);
}
export function hasNullRect(cr) {
    if (!cr)
        return true;
    if (!cr.rect)
        return true;
    if (!cr.rect.x)
        return true;
    return false;
}
export function hasSameRect(prev_cr, next_cr) {
    if (hasNullRect(next_cr))
        return false;
    if (hasNullRect(prev_cr))
        return false;
    return isSameRect(prev_cr.rect, next_cr.rect);
}
export function isSameArray(p1, p2) {
    if (!p1 && !p2)
        return true;
    if (!p1 && p2)
        return false;
    if (p1 && !p2)
        return false;
    if (p1.length !== p2.length)
        return false;
    // for (let i = 0; i < p1.length; i++)
    //   if (!p2.includes(p1[i])) return false;
    // for (let i = 0; i < p2.length; i++)
    //   if (!p1.includes(p2[i])) return false;
    // return true;
    const intersection = p1.filter(p1_item => p2.includes(p1_item));
    if (intersection.length !== p1.length)
        return false;
    return true;
}
/**
 * string.right()
 *
 * @export
 * @param {string} str
 * @param {number} n
 * @return {*}  {string}
 */
export function strRight(str, n) {
    if (n <= 0)
        return "";
    else if (n > String(str).length)
        return str;
    else {
        const iLen = String(str).length;
        return String(str).substring(iLen, iLen - n);
    }
}
/**
 * Return a string only with valid characters
 *
 * @export
 * @param {string} target
 * @param {string} validChars - valid character set
 * @param {boolean} [makeUpper]
 * @param {number} [maxLen]
 * @return {*}  {string}
 */
export function removeInvalidChar(target, validChars, makeUpper, maxLen) {
    const val = makeUpper ? target.toUpperCase() : target;
    let ret = "";
    for (let i = 0, l = val.length; i < l; i++) {
        const hexIndex = validChars.indexOf(val.charAt(i));
        if (hexIndex >= 0) {
            if (maxLen && ret.length < maxLen)
                ret = ret + val.charAt(i);
        }
    }
    return ret;
}
export function getCssValue(name) {
    return getComputedStyle(document.documentElement).getPropertyValue(`${name} `);
}
export const getTimeStringFormatted = (ms, format = null) => {
    let sec = Math.floor(ms / 1000);
    // let mili = miliseconds - sec * 1000;
    // let deci = Math.round(mili / 100);
    let mm = Math.floor(sec / 60);
    let hh = Math.floor(mm / 60);
    const dd = Math.floor(hh / 24);
    hh = hh - dd * 24;
    mm = mm - hh * 60;
    sec = sec - hh * 3600 - mm * 60;
    let mm_str = "0" + mm;
    let ss_str = "0" + sec;
    let hh_str = "0" + hh;
    const dd_str = "" + dd;
    ss_str = ss_str.substr(-2);
    mm_str = mm_str.substr(-2);
    hh_str = hh_str.substr(-2);
    if (!format)
        return `${hh_str}: ${mm_str}: ${ss_str} `;
    let ret_val = format;
    if (dd > 0) {
        ret_val = ret_val.replace("d", `${dd_str} `);
    }
    else {
        ret_val = ret_val.replace("d", "");
    }
    ret_val = ret_val.replace("hh", `${hh_str} `);
    ret_val = ret_val.replace("mm", `${mm_str} `);
    ret_val = ret_val.replace("ss", `${ss_str} `);
    return ret_val;
};
export const getTimeString = (ms) => {
    const a = new Date(ms);
    const time_str_locale = a.toLocaleTimeString("en-GB");
    return time_str_locale;
};
export const getDateString = (ms) => {
    const a = new Date(ms);
    // const lang = navigator.languages;
    // const time_str_24 = a.toLocaleTimeString('en-GB');
    // const time_str_locale = a.toLocaleTimeString(lang ? lang[0] : "en-GB");
    const year = a.getFullYear();
    const month = a.getMonth() + 1;
    const wday = a.getDay();
    const day = a.getDate();
    // const hour = a.getHours();
    // const min = a.getMinutes();
    // const sec = a.getSeconds();
    const weekdays = ["일", "월", "화", "수", "목", "금", "토"];
    const ret = sprintf("%04d-%02d-%02d(%s)", year, month, day, weekdays[wday]);
    return ret;
};
export const isSameDay = (ms1, ms2) => {
    return getDateString(ms1) === getDateString(ms2);
};
export const getDateTimeString = (ms) => {
    return getDateString(ms) + " " + getTimeString(ms);
};
export const getYMDhmsString = (d) => {
    const dateTimeStr = sprintf("%04d%02d%02d_%02d%02d", d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds());
    return dateTimeStr;
};
export function isInRect(rc, pt) {
    if (pt.x < rc.x)
        return false;
    if (pt.y < rc.y)
        return false;
    if (pt.x >= rc.x + rc.width)
        return false;
    if (pt.y >= rc.y + rc.height)
        return false;
    return true;
}
export function unionRect(r1, r2) {
    const left = Math.min(r1.left, r2.left);
    const right = Math.max(r1.right, r2.right);
    const top = Math.min(r1.top, r2.top);
    const bottom = Math.max(r1.bottom, r2.bottom);
    return { left, right, top, bottom };
}
export function intersectRect(r1, r2) {
    const left = Math.max(r1.left, r2.left);
    const right = Math.min(r1.right, r2.right);
    const top = Math.max(r1.top, r2.top);
    const bottom = Math.min(r1.bottom, r2.bottom);
    const width = right - left;
    const height = bottom - top;
    if (width < 0 || height < 0)
        return null;
    return { left, right, top, bottom };
}
export function hasIntersectRect(r1, r2) {
    return !(r2.left > r1.right ||
        r2.right < r1.left ||
        r2.top > r1.bottom ||
        r2.bottom < r1.top);
}
export function getBoundingBox(stroke) {
    if (stroke.dotArray.length < 1) {
        return {
            left: -1,
            right: -1,
            top: -1,
            bottom: -1,
        };
    }
    const box = {
        left: stroke.dotArray[0].x,
        top: stroke.dotArray[0].y,
        right: stroke.dotArray[0].x,
        bottom: stroke.dotArray[0].y,
    };
    for (let i = 1, l = stroke.dotArray.length; i < l; i++) {
        const dot = stroke.dotArray[i];
        if (dot.x < box.left) {
            box.left = dot.x;
        }
        else if (dot.x > box.right) {
            box.right = dot.x;
        }
        if (dot.y < box.top) {
            box.top = dot.y;
        }
        else if (dot.y > box.bottom) {
            box.bottom = dot.y;
        }
    }
    return box;
}
export function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    let byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);
    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to a typed array
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
}
//# sourceMappingURL=functions.js.map